<div class="section-card">
    <h6 class="section-title text-center">
        <i class="bi me-2"></i>
        {{ titulo }}
    </h6>

    <!-- 🔹 Filtro generico -->
    <app-generic-filter
        [items]="productos"
        (filtered)="productosFiltrados = $event"
        placeholder="Buscar producto..."></app-generic-filter>

    <div class="product-container">
        <div class="product-list">
            <div
                *ngFor="let producto of productosFiltrados; let i = index"
                class="product-card"
                [class.selected]="tipo === 'seleccionados'">
                <div class="product-order" *ngIf="tipo === 'seleccionados'">
                    {{ i + 1 }}
                </div>

                <div class="product-info">
                    <div class="product-name">{{ producto.descripcion }}</div>
                    <span
                        class="type-badge"
                        [style.background]="getTipoColor(producto.tipoId)">
                        {{ getTipoNombre(producto.tipoId) }}
                    </span>
                </div>

                <button
                    *ngIf="tipo === 'disponibles'"
                    class="btn btn-action btn-add"
                    (click)="agregarProducto.emit(producto)"
                    title="Agregar producto">
                    →
                </button>

                <button
                    *ngIf="tipo === 'seleccionados'"
                    class="btn btn-action btn-remove"
                    (click)="quitarProducto.emit(producto)"
                    title="Quitar producto">
                    ←
                </button>
            </div>

            <div *ngIf="productosFiltrados.length === 0" class="empty-state">
                <i
                    class="bi"
                    [class]="
                        tipo === 'disponibles'
                            ? 'bi-inbox empty-icon'
                            : 'bi-cart empty-icon'
                    "></i>
                <p>
                    {{
                        tipo === 'disponibles'
                            ? 'No hay productos disponibles'
                            : 'No hay productos seleccionados'
                    }}
                </p>
                <small class="text-muted">
                    {{
                        tipo === 'disponibles'
                            ? 'Selecciona tipos de productos para ver las opciones'
                            : 'Agrega productos desde la lista disponible'
                    }}
                </small>
            </div>
        </div>
    </div>
</div>
